import { Button, FlexColumn, FlexRow, renderDecimal, useDebouncedValue } from '@synqo/frontend-component-library';
import { useStorageStock } from '../Stock/useStorageStock';
import classes from './AvvSuggestions.module.css';
import { avvSuggestions, MAX_AVV_BUTTONS } from './avvSuggestions';
import { STOCK_DEBOUNCE_MS } from './previewLine';

interface IProps {
    storageLocationId: string | undefined;
    materialId: string | undefined;
    avvId: string | undefined;
    occurredAt: string;
    /** Links the AVV with this id into the booking. */
    onSelect: (avvId: string) => void;
}

/** The AVVs under which the chosen Lagerort holds the chosen material, as buttons, or a warning when there are many. */
// @ai-generated 2026-10-27T12:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function AvvSuggestions({ storageLocationId, materialId, avvId, occurredAt, onSelect }: IProps) {
    const settledAt = useDebouncedValue(occurredAt, STOCK_DEBOUNCE_MS);
    const known = !!storageLocationId && !!materialId && !avvId && !!settledAt;
    const stock = useStorageStock({ storageLocationId, validAt: settledAt, enabled: known });

    const suggestions =
        known && !stock.isLoading && !stock.failure ? avvSuggestions(stock.entries, materialId, avvId) : [];
    if (suggestions.length === 0) {
        return undefined;
    }

    if (suggestions.length > MAX_AVV_BUTTONS) {
        return (
            <FlexRow className={classes.warning}>
                Dieses Material wird bereits unter {suggestions.length} AVVs geführt. Bitte eintragen.
            </FlexRow>
        );
    }

    return (
        <FlexColumn gap="xs" align="flex-start">
            <FlexRow>Dieses Material wird bereits unter folgenden AVVs geführt:</FlexRow>
            <FlexRow wrap="wrap">
                {suggestions.map((suggestion) => (
                    <Button key={suggestion.id} variant="secondary" size="xs" onClick={() => onSelect(suggestion.id)}>
                        {suggestion.label} · {renderDecimal(suggestion.quantity, 3)} t
                    </Button>
                ))}
            </FlexRow>
        </FlexColumn>
    );
}
